import { LogCannon } from '@ace-clublabs/log-cannon';

interface LogMessage {
  message:
    | {
        [key: string]: unknown;
      }
    | string;
  level: string;
  utcTimeStamp: number;
}

export interface LogRequestParams {
  message: string;
  level: string;
  data: {
    [key: string]: unknown;
  };
}

export interface LogResponse {
  [key: string]: unknown;
}

interface LogObject {
  response?: LogResponse;
  level?: string;
  [key: string]: unknown;
}

export const blastDataToLogCannon = (
  logObject: LogObject,
  logName: string = 'TRVL-BROWSER-API-RESULT',
) => {
  try {
    const logBrowserData: LogRequestParams = {
      message: '',
      level: logObject.level ?? 'info',
      data: {
        log: logName,
        'user-agent': navigator.userAgent,
        ...logObject,
        'confirmation-id': logObject.response?.confirmationId
          ? logObject.response?.confirmationId
          : 'N/A',
      },
    };

    const logMessage: LogMessage = {
      level: logBrowserData.level,
      message: logBrowserData.data,
      utcTimeStamp: Date.now(),
    };

    LogCannon.blast('trvl-browser-log', logMessage);
  } catch {}
};
